var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-bar",class:_vm.type},[(_vm.icon !== false)?_c('Icon',{staticClass:"tip-icon",attrs:{"type":_vm.iconType}}):_vm._e(),_c('div',{staticClass:"tip-body"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }